require('./prtv-depot-facture-3.scss');

import DemandeActions from '../../../../actions/demande.actions';
import { STEPS } from '../../../../utils/routes.util';
export default class PrtvDepotFacture3Component {
  constructor() {
    this.controller = PrtvDepotFacture3Controller;
    this.template = require('./prtv-depot-facture-3.html');
  }
}

// @ngInject
class PrtvDepotFacture3Controller {

  constructor($scope, $ngRedux) {
    this.$ngRedux = $ngRedux;
    this.$scope = $scope;
    this.data = {};
  }

  $onInit() {
    // Demande de récupération de la demande avant connexion au state
    this.$ngRedux.dispatch(DemandeActions.loadDemande(STEPS.PRTV_DEPOT_FACTURE_3));

    // Connexion au state récupérer les données modifiées
    const disconnect = this.$ngRedux.connect(
      state => {
        return {
          working: state.general.working,
          failure: state.demande.failure,
          fetching: state.demande.fetching,
          data: state.demande.data.prtvDepotFacture2 ? state.demande.data.prtvDepotFacture2.asMutable({deep: true}) : this.data,
          demande: state.demande.data,
          demandeEnquetePapier: state.demande.data.prtvInterface1 ? state.demande.data.prtvInterface1.demandeEnquetePapier :
            state.demande.data.demandeEnquete ? state.demande.data.demandeEnquete : false,
          factureFileName: state.demande.data.prtvDepotFacture ? state.demande.data.prtvDepotFacture.factureFileName : null,
          typePersonne: state.demande.data.typePersonne ? state.demande.data.typePersonne : '',
          nom: state.demande.data.prtvInterface1 ? state.demande.data.prtvInterface1.nom :
            state.demande.data.suivieAuthent ? state.demande.data.suivieAuthent.nom : '',
          prenom: state.demande.data.prtvInterface1 ? state.demande.data.prtvInterface1.prenom :
            state.demande.data.suivieAuthent ? state.demande.data.suivieAuthent.prenom : '',
          checkCode: state.demande.data ? state.demande.data.checkCode : '',
          numeroAnfr: state.demande.data ? state.demande.data.numeroAnfr : ''
        };
      }
    )(this);
    // Déconnexion du state à la suppression du composant
    this.$scope.$on('$destroy', disconnect);
    this.disableNext = true;
  }

  // Actions
  prevStep() {
    this.$ngRedux.dispatch(DemandeActions.updatePrtvDepotFacture3(this.data, true));
  }
  nextStep() {
    this.$ngRedux.dispatch(DemandeActions.updatePrtvDepotFacture3(this.data));
  }
}



// WEBPACK FOOTER //
// ./src/modules/prtv/components/prtv-depot-facture-3/prtv-depot-facture-3.component.js